import styled from 'styled-components'
import { Switch } from 'antd'

export const PrescriptionItem = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${({ status }) => status?.toLowerCase().includes('error') ? 'rgb(255, 0, 0)' : '#000'};
    padding: 10px 20px;
    border-radius: 5px;
    margin-bottom: 10px;
    font-weight: bold;
    font-size: .7rem;
    background-color: ${({ status }) => status?.toLowerCase().includes('error') ? 'rgba(255, 77, 0, 0.13)' : 'rgba(123, 173, 126, 0.15)'};
`

export const PrescriptionDateCategories = styled.div`
    color: ${({ status }) => status?.toLowerCase().includes('error') ? 'rgb(255, 0, 0)' : '#7BAD7E'};
    font-size: .8rem;
`

export const Title = styled.div`
    text-transform: capitalize;
`

export const Pharmacy = styled.div`
    margin-top: 6px;
    align-self: flex-end;
    font-size: 0.65rem;
    font-weight: normal;
    color: #666;
`

export const Status = styled.div`
    align-self: flex-end;
    font-size: 0.65rem;
    font-weight: normal;
    color: #666;
`

export const Directions = styled.div`
    font-weight: normal;
`

export const SyncMeta = styled.div`
    align-self: flex-end;
    font-size: 0.65rem;
    font-weight: normal;
    color: #666;
`;

export const ShowErrorsSwitch = styled(Switch)`

    &.ant-switch {
        background-color: rgb(123, 173, 126) !important;
    }

    &.ant-switch-checked {
        background-color: red !important;
    }
`

export const Provider = styled.div`
    align-self: flex-end;
    font-size: 0.65rem;
    font-weight: normal;
    color: #666;
`